import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitonarmadaparikramacab() {



  const cardData =
  {
    keyword: 'Mumbai to Narmada Parikrama Cab Booking ',
    heading: 'Shambhu Cabs: Mumbai to Narmada Parikrama Cab Booking ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Narmada Parikrama Cab Booking services, providing safe, comfortable, and seamless travel for devotees, families, spiritual groups, and long-distance travelers embarking on the sacred Narmada Parikrama Yatra. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and peaceful journey with well-maintained vehicles and spacious seating ideal for multi-day trips. With flexible one-way, round-trip, and customized pilgrimage travel plans, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes your spiritual journey stress-free and convenient. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Narmada Parikrama cab services for travelers seeking comfort, safety, devotion-friendly arrangements, and a reliable travel experience throughout the yatra.',

    top: 'Top Places to Visit in Narmada Parikrama with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Omkareshwar",
    "description": "Omkareshwar, one of the twelve Jyotirlingas, is situated on Mandhata Island in the Narmada River, shaped like the sacred ‘ॐ’ symbol. This unique geography makes the place one of the holiest stops in the Narmada Parikrama. Pilgrims believe that walking around the island brings spiritual purification and blessings from Lord Shiva. The ancient Omkareshwar Temple stands on the banks, surrounded by ghats, bridges, and scenic hills. The sound of temple bells, the chanting of mantras, and the constant flow of devotees create an atmosphere filled with devotion. Many Parikrama walkers rest here for darshan, meditation, and river rituals. The river's calm current and the sacred pathways make Omkareshwar one of the most spiritually powerful points on the entire Parikrama route."
  },
  {
    "title": "Maheshwar",
    "description": "Maheshwar is one of the most ancient and culturally rich places along the Narmada River. Known for the majestic Ahilya Fort, built and renovated by Maharani Ahilyabai Holkar, this town is considered the spiritual heart of the Parikrama. The riverfront ghats, such as Ahilya Ghat and Peshwa Ghat, are among the most beautiful in India, with intricate stonework and serene steps leading into the sacred river. Maheshwar is also home to over a hundred ancient temples dedicated to Shiva, Vishnu, and various goddesses. Parikrama pilgrims stop here for rituals, meditation, and rest, as the town offers safe shelters, food, and peaceful surroundings. The sound of ‘Narmade Har’ chants, constant lamp offerings, and boat rides on the river make Maheshwar a deeply moving spiritual experience."
  },
  {
    "title": "Amarkantak",
    "description": "Amarkantak, located in the lush Vindhya and Satpura ranges, is the origin point of the Narmada River and the most sacred starting spot for many Parikrama devotees. Also known as ‘Tirthraj’—the King of Pilgrimages—it is home to dense forests, waterfalls, and ancient temples that reflect centuries of spiritual heritage. The Narmada Udgam Temple marks the river’s birth, and pilgrims perform prayers here before beginning the long circumambulation journey. The natural landscape of Amarkantak is filled with medicinal plants and serene pathways used by sages, including traditions linked to Adi Shankaracharya. Many people believe that just visiting the river's source removes negative karma and opens the path to spiritual clarity. For Parikrama walkers, Amarkantak is both a beginning filled with hope and a place of deep blessings."
  },
  {
    "title": "Hoshangabad (Narmadapuram)",
    "description": "Hoshangabad, now known as Narmadapuram, is a peaceful riverside town that serves as an important resting and ritual point for Parikrama travelers. The Narmada flows wide and calm here, making it ideal for bath rituals and evening aarti. Ram Ghat is one of the most beautiful stretches, where thousands gather to offer diyas and prayers. The town has several temples dedicated to Lord Shiva and other deities, reflecting centuries of devotion to the river. The surrounding region features scenic pathways, forests, and villages that warmly host Parikrama walkers. The presence of traditional Narmada-seva groups offering food, shelter, and guidance makes Hoshangabad a comforting waypoint on the long spiritual journey."
  },
  {
    "title": "Narmada Har Parikrama Route Villages",
    "description": "The true essence of Narmada Parikrama lies in walking through the hundreds of small riverside villages spread across Madhya Pradesh, Gujarat, and Maharashtra. These villages—such as Tilakeshwar, Nemawar, Rajpipla, Kevadiya, Garudeshwar, Bharuch and many more—provide a real spiritual and cultural experience that cannot be found in any single tourist spot. Pilgrims follow the ancient rule of walking only on foot, keeping the river on their right side, and never crossing it during the entire journey. Villagers welcome Parikrama yatris with food, tea, rest spaces, and heartfelt hospitality. Along this route, one will find old temples, ashrams, forest paths, river ghats, and sacred spots associated with saints like Shree Gondavalekar Maharaj, Kapildhara Rishi, and countless Narmada sadhus. Every halt teaches simplicity, devotion, and the power of faith. These villages represent the living soul of the Parikrama—the journey, not the destination, is the blessing."
  }
],




"services": [
  {
    "name": "Narmada Parikrama Taxi Mumbai",
    "description": "Narmada Parikrama Taxi Mumbai provides reliable long-distance pilgrimage travel for devotees beginning their sacred Narmada Parikrama journey from Mumbai. The service includes experienced drivers, comfortable vehicles, flexible routes, and complete support for multi-day travel. Designed for spiritual seekers, this cab service offers safe transport across temples, ghats, ashrams, and holy destinations along the Narmada River, ensuring a peaceful and stress-free pilgrimage experience."
  },
  {
    "name": "Mumbai Narmada Yatra Cab",
    "description": "Mumbai Narmada Yatra Cab is ideal for devotees undertaking the sacred Narmada Yatra from Mumbai. Offering well-maintained vehicles, professional chauffeurs, and customized circuit planning, this service supports long-route travel across Madhya Pradesh and Gujarat. Perfect for small groups, families, and senior citizens, it ensures comfortable travel to all major Narmada Yatra points with complete safety and spiritual convenience."
  },
  {
    "name": "Parikrama Tour Cab Mumbai",
    "description": "Parikrama Tour Cab Mumbai offers fully-managed cab services for the entire Narmada Parikrama circuit. The service includes route planning, multi-day travel options, temple visits, flexible schedules, and safe long-distance driving. Ideal for spiritual tours, traditional parikrama devotees, and family groups seeking a reliable and comfortable travel experience throughout the sacred journey."
  },
  {
    "name": "Affordable Narmada Parikrama Cab",
    "description": "Affordable Narmada Parikrama Cab provides budget-friendly travel solutions for devotees looking for economical yet comfortable options for their multi-day Parikrama journey. The service includes well-maintained sedans and SUVs, transparent pricing, and dedicated chauffeur support. Perfect for pilgrims who want a smooth, affordable long-distance journey without compromising safety."
  },
  {
    "name": "Best Narmada Cab from Mumbai",
    "description": "Best Narmada Cab from Mumbai ensures top-quality vehicles, professional drivers, and premium travel comfort for the spiritual journey along the Narmada river. Ideal for families, elderly devotees, and large groups, the service guarantees smooth intercity travel, clean interiors, and complete route flexibility to cover all major Narmada Parikrama destinations."
  },
  {
    "name": "SUV Cab Narmada Trip",
    "description": "SUV Cab Narmada Trip offers spacious and powerful SUVs specially suited for long-distance pilgrimage travel. With excellent suspension, extra luggage capacity, and comfortable seating, SUVs ensure a smooth ride through rural roads, hill paths, and extended highway stretches. Ideal for groups and families seeking a premium and stable travel experience."
  },
  {
    "name": "Sedan Cab Narmada Parikrama",
    "description": "Sedan Cab Narmada Parikrama provides comfortable, cost-effective, and air-conditioned sedans for devotees beginning their parikrama from Mumbai. Perfect for small families, couples, and solo pilgrims, sedans offer great mileage, smooth travel comfort, and reliable long-route performance throughout the multi-day pilgrimage."
  },
  {
    "name": "Long Route Cab Mumbai Narmada",
    "description": "Long Route Cab Mumbai Narmada is designed specifically for extended pilgrimage journeys, multi-day temple visits, and long-distance travel requirements. With experienced long-route chauffeurs, spacious vehicles, and customizable itineraries, this service ensures uninterrupted travel with complete safety and convenience across hundreds of kilometers."
  },
  {
    "name": "24×7 Parikrama Taxi Mumbai",
    "description": "24×7 Parikrama Taxi Mumbai provides round-the-clock availability for devotees starting their spiritual journey at any hour. Whether for early morning departures, overnight travel, or emergency pickups, the service offers dependable, punctual, and safe cab options for the entire Narmada Parikrama circuit."
  },
  {
    "name": "Pilgrimage Cab Mumbai Narmada",
    "description": "Pilgrimage Cab Mumbai Narmada is specifically tailored for spiritual travelers, offering devotional-friendly travel, calm driving, and complete support throughout the Narmada pilgrimage. Drivers are familiar with key temples, dharamshalas, ghats, and holy stops, ensuring a smooth and spiritually aligned travel experience."
  },
  {
    "name": "Corporate Cab Mumbai Narmada",
    "description": "Corporate Cab Mumbai Narmada provides premium and professionally managed cab services for corporate groups, company-sponsored pilgrimages, and business executives combining work with spiritual travel. With luxury vehicles, professional chauffeurs, and long-distance travel reliability, this service ensures a superior travel experience."
  },
  {
    "name": "Premium Parikrama Cab",
    "description": "Premium Parikrama Cab offers luxury sedans and SUVs with plush interiors, superior comfort, and personalized services for devotees seeking an upscale travel experience. Ideal for VIP guests, senior citizens requiring extra comfort, and families wanting a luxurious Narmada Parikrama journey."
  },
  {
    "name": "Safe Narmada Parikrama Cab",
    "description": "Safe Narmada Parikrama Cab prioritizes traveler safety with verified drivers, GPS tracking, sanitized vehicles, and careful long-route driving. The service ensures complete peace of mind for women travelers, elderly devotees, and families throughout the long spiritual journey."
  },
  {
    "name": "Mumbai Narmada Pickup Drop",
    "description": "Mumbai Narmada Pickup Drop provides point-to-point transfers from any location in Mumbai to major Narmada Parikrama starting points in Madhya Pradesh and Gujarat. The service offers flexible timing, hassle-free travel coordination, and smooth long-distance transportation tailored to pilgrimage schedules."
  },
  {
    "name": "Mumbai Narmada Tour Package Cab",
    "description": "Mumbai Narmada Tour Package Cab offers a complete pilgrimage package including multi-day cab rental, route planning, temple visit schedules, and customized itineraries. Ideal for families, groups, and spiritual travelers seeking an all-inclusive cab service for the entire Narmada Yatra."
  },
  {
    "name": "Family Cab Narmada Parikrama",
    "description": "Family Cab Narmada Parikrama provides spacious and family-friendly vehicles designed for comfortable multi-day travel. With ample luggage space, careful drivers, and smooth travel support, this service ensures a peaceful and secure pilgrimage experience for families of all sizes."
  },
  {
    "name": "Outstation Parikrama Cab",
    "description": "Outstation Parikrama Cab offers flexible and reliable intercity travel options for extended Narmada Parikrama routes. With expert drivers, long-route-ready vehicles, and customizable travel plans, this cab service is ideal for pilgrims covering multiple states over several days."
  }
],

"tableData": [
  ["Narmada Parikrama Taxi Mumbai", "Mumbai Narmada Yatra Cab"],
  ["Parikrama Tour Cab Mumbai", "Affordable Narmada Parikrama Cab"],
  ["Best Narmada Cab from Mumbai", "SUV Cab Narmada Trip"],
  ["Sedan Cab Narmada Parikrama", "Long Route Cab Mumbai Narmada"],
  ["24×7 Parikrama Taxi Mumbai", "Pilgrimage Cab Mumbai Narmada"],
  ["Corporate Cab Mumbai Narmada", "Premium Parikrama Cab"],
  ["Safe Narmada Parikrama Cab", "Mumbai Narmada Pickup Drop"],
  ["Mumbai Narmada Tour Package Cab", "Family Cab Narmada Parikrama"],
  ["Outstation Parikrama Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Narmada Parikrama Cab Booking with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers dependable Mumbai to Narmada Parikrama cab services, ideal for spiritual journeys, pilgrimage travel, and long-distance tours."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly maintained cabs to ensure a comfortable and peaceful journey during your Narmada Parikrama Yatra."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pilgrimage and Long Routes",
    "WhyChoosedescription": "Our skilled drivers are knowledgeable about long pilgrimage routes, ensuring safe, smooth, and timely travel throughout your Narmada Parikrama trip."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Narmada Parikrama cab booking hassle-free and reliable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel planning, and route guidance for your spiritual journey."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Pilgrimage Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customizable multi-day rental plans tailored to the requirements of your Narmada Parikrama Yatra."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip, ensuring a hygienic and safe travel experience during your pilgrimage."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai to Narmada Parikrama journey smooth, comfortable, and stress-free."
  }
]


























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Narmada Parikrama cab booking services?',
    answer: 'Yes, Shambhu Cabs provides safe and reliable Mumbai to Narmada Parikrama cab booking services with expert drivers familiar with long pilgrimage routes.',
  },
  {
    question: 'How can I book a Mumbai to Narmada Parikrama cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for fast and convenient booking.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Narmada Parikrama cab bookings?',
    answer: 'Shambhu Cabs offers comfortable sedans, spacious SUVs, and luxury vehicles suitable for multi-day pilgrimage travel.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Narmada Parikrama route?',
    answer: 'Yes, our drivers are professionally trained, licensed, and experienced in handling long-distance pilgrimage routes including Narmada Parikrama circuits.',
  },
  {
    question: 'Can I customize pickup and drop-off points for Mumbai to Narmada Parikrama cab service?',
    answer: 'Absolutely. You can choose any pickup location in Mumbai and customize your drop-off points according to your Narmada Parikrama itinerary.',
  },
  {
    question: 'Is the Mumbai to Narmada Parikrama cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock cab booking services to match your travel plans and pilgrimage schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mumbai to Narmada Parikrama cab bookings?',
    answer: 'All vehicles undergo regular sanitization and our drivers strictly follow safety and hygiene guidelines to ensure your well-being throughout the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Narmada Parikrama cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and provide billing options for corporate accounts.',
  },
  {
    question: 'Is customer support available during the Mumbai to Narmada Parikrama trip?',
    answer: 'Yes, our 24x7 customer support team is available for assistance at every stage of your Narmada Parikrama journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Mahesh Shinde',
    feedback: 'Shambhu Cabs made our Mumbai to Narmada Parikrama journey peaceful and comfortable. Excellent driver and very well-maintained car.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sunita Deshpande',
    feedback: 'Highly reliable service for Narmada Parikrama. Safe driving, clean vehicle, and great support throughout the pilgrimage.',
    rating: 5,
  },
];
















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Narmada Parikrama Cab Booking",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-narmada-parikrama-cab.jpg",
  "description": "Shambhu Cabs offers safe and reliable Mumbai to Narmada Parikrama cab services for pilgrimage tours, family trips, and corporate travel. Book sedans, SUVs, or premium cars for long route journeys with professional drivers. Enjoy 24×7 service, affordable fares, and convenient pickup-drop options for the Narmada Parikrama yatra.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-narmada-parikrama-cab-booking"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Narmada Parikrama Cab | Pilgrimage & Outstation Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Narmada Parikrama cab with Shambhu Cabs. Safe, affordable, and comfortable taxi service for pilgrimage tours, family trips, and corporate travel. Available 24×7 with sedans, SUVs, and premium cars, including pickup-drop for Narmada Parikrama yatra."
  />

  <meta
    name="keywords"
    content="Narmada Parikrama Taxi Mumbai, Mumbai Narmada Yatra Cab, Parikrama Tour Cab Mumbai, Affordable Narmada Parikrama Cab, Best Narmada Cab from Mumbai, SUV Cab Narmada Trip, Sedan Cab Narmada Parikrama, Long Route Cab Mumbai Narmada, 24×7 Parikrama Taxi Mumbai, Pilgrimage Cab Mumbai Narmada, Corporate Cab Mumbai Narmada, Premium Parikrama Cab, Safe Narmada Parikrama Cab, Mumbai Narmada Pickup Drop, Mumbai Narmada Tour Package Cab, Family Cab Narmada Parikrama, Outstation Parikrama Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/21.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitonarmadaparikramacab;